<div class="zoom-overlay" (click)="close()">

  <div class="zoom-bar">
    <span class="zoom-name">{{ title }}</span>
    <button type="button" class="zoom-close" (click)="close()">✕</button>
  </div>

  <div class="zoom-stage" *ngIf="image">
    <button
      type="button"
      class="zoom-nav prev"
      *ngIf="images.length > 1"
      (click)="step(-1, $event)"
    >‹</button>

    <img [src]="image.url" alt="" (click)="stop($event)" />

    <button
      type="button"
      class="zoom-nav next"
      *ngIf="images.length > 1"
      (click)="step(1, $event)"
    >›</button>
  </div>

  <div class="zoom-foot">
    <span class="zoom-label" *ngIf="image?.label">{{ image?.label }}</span>
    <span class="zoom-count" *ngIf="images.length > 1">
      {{ current + 1 }}/{{ images.length }}
    </span>
  </div>

</div>
